(function () {
	'use strict';
	$(document).ready(function () {

		var swiperCaseStudies = new Swiper('.swiper-case-studies', {
			slidesPerView: 1,
			spaceBetween: 1,
			navigation: {
				prevEl: '.case-studies .swiper-button-prev',
				nextEl: '.case-studies .swiper-button-next',
			},
			pagination: {
				el: '.case-studies .swiper-pagination',
				type: 'bullets',
				clickable: true,
			},
			breakpoints: {
				768: {
					slidesPerView: 3,
				},
			}
		});

		if (window.matchMedia("(min-width: 768px)").matches) {
			ScrollTrigger.create({
				trigger: ".case-study .testimonial",
				pin: ".case-study .col-quote-wrapper",
				start: "bottom bottom",
				endTrigger: ".case-study .col-texts",
				end: "bottom bottom",
			});
		}

	});
}(jQuery));
